import styled from 'styled-components';

export const StyledIssuesList = styled.div`
  margin-top: -1rem;
  height: 70rem;
  overflow-y: scroll;
  & .MuiTableCell-root {
    padding: 0 1rem;
  }
`;
